function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenericCsvLightLarge = function SvgGenericCsvLightLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235 153"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 235,
    height: 153,
    rx: 16,
    ry: 16,
    style: {
      fill: "#a2a9a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.28 62.522c0-.313.085-.62.246-.889l2.706-4.51a1.73 1.73 0 0 1 1.482-.839h12.269c.954 0 1.728.774 1.728 1.728v24.191c0 .954-.774 1.728-1.728 1.728H21.714a1.728 1.728 0 0 1-1.482-.839l-2.706-4.51a1.73 1.73 0 0 1-.246-.889v-15.17Zm20.735-4.511c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728v-9.216Zm13.248-1.728c-.954 0-1.728.774-1.728 1.728v12.672c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728V58.011c0-.954-.774-1.728-1.728-1.728h-5.76ZM38.015 72.987c0-.954.774-1.728 1.728-1.728h5.76c.954 0 1.728.774 1.728 1.728v9.216c0 .954-.774 1.728-1.728 1.728h-5.76a1.728 1.728 0 0 1-1.728-1.728v-9.216Zm13.248 1.729c-.954 0-1.728.774-1.728 1.728v5.76c0 .954.774 1.728 1.728 1.728h5.76c.954 0 1.728-.774 1.728-1.728v-5.76c0-.954-.774-1.728-1.728-1.728h-5.76Z",
    style: {
      fill: "#fffaf0",
      fillRule: "evenodd",
      isolation: "isolate",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.625 29.5a5.875 5.875 0 0 1 5.875-5.875h47a5.875 5.875 0 0 1 5.875 5.875v35.25a5.875 5.875 0 0 1-5.875 5.875h-47a5.875 5.875 0 0 1-5.875-5.875V29.5Zm5.875 5.875v11.75h20.562v-11.75H164.5Zm26.437 0v11.75H211.5v-11.75h-20.563ZM185.062 53H164.5v11.75h20.562V53Zm5.875 11.75V53H211.5v11.75h-20.563Z",
    style: {
      fill: "#fffaf0",
      fillRule: "evenodd"
    }
  }));
};
export default SvgGenericCsvLightLarge;